import { MIME_TYPES } from '@mantine/dropzone';
import { invokeEvent } from 'shared-base';

export const imageUrlToFile = async (url: string) => {
  try {
    const fileName = url.split('/').pop() ?? 'image.png';

    // Fetch the image from the relative URL
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch the image from ${url}`);
    }

    // Convert the response to a Blob
    const blob = await response.blob();

    // Create a File from the Blob
    const file = new File([blob], fileName, { type: MIME_TYPES.png });

    return file;
  } catch (err) {
    invokeEvent('sentry', { err });
  }
};
